import { FtuxConfig, FtuxStep } from '../types';
import { ensureLastStepIsDone } from './utils';

export const getRecordSpellingConfig = (): FtuxConfig => {
	const steps: FtuxStep[] = [
		{
			type: 'modal' as const,
			title: 'Recording assessment results',
			subtitle:
				'You can conduct and record student assessment data for each Little Learners assessment for a particular assessment period on the Online Platform.',
			image: '/img/ftux-record-spelling-1.png',
			button: {
				label: 'Next',
				type: 'paginated' as const,
				hasBackButton: false
			},
			modalPosition: 'bottom-right' as const,
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#recording-date',
			subtitle: 'Click here to change the assessment recording date.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#student-view',
			subtitle: 'You can stay on the same assessment type but change the student you are viewing here.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#graphene-spelling-letter',
			subtitle: 'Quickly switch to another student in the same class by clicking here.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#spelling-word-marking-buttons',
			subtitle:
				'Click the tick or cross button to mark the entire question as correct/incorrect.<br/><br/><strong>Tip:</strong> You can use this in conjunction with the tile buttons to mark fully correct first and then specific tiles incorrect.',
			tooltipPlacement: 'bottom' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#notes-view',
			subtitle: 'Add supporting notes for any incorrect answers for future reference.',
			tooltipPlacement: 'right' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		},
		{
			type: 'tooltip' as const,
			target: '#score-view',
			subtitle:
				'Each question with all correct tile(s) will add 1 point to the total score.<br/><br/>Questions marked with some or all tiles marked incorrect will not add any additional points to the score.',
			tooltipPlacement: 'left' as const,
			button: {
				label: 'Next',
				type: 'paginated' as const
			},
			hasBackdrop: false
		}
	];

	const config: FtuxConfig = {
		id: 'record-spelling-ftux',
		name: 'Record Spelling Tutorial',
		showSkipButton: false,
		steps
	};

	// Ensure the last step always has "Done" as the label
	return ensureLastStepIsDone(config);
};
